import axios from 'axios';
/**
 * cấu hình toàn bộ các url của các api microservice theo phân hệ
 * @author DNThang - 03.07.2019
 * @Edit NDQUAN - 10/08/2019
 */
//Lấy DNS môi trường
let host = process.env.VUE_APP_SERVERHOST;

//Cấu hình api config dành cho môi trường local
const apiConfigDevLocal = {
	InvoiceBotsAPI: host + ':2460',
	SignalR: host + ':21837',
	// SignalR: 'https://inbotpush.meinvoice.misa.local',
	InvoiceBotTrialsAPI: host + ':1500',
	InternalAPI: host + ':31156'
};

//Cấu hình api config dành cho môi trường production
const apiConfigProduction = {
	//InvoiceBotsAPI: `${process.env.BASE_URL}api/`+ window.__env.ConfigApplication.groupApplication,
	InvoiceBotsAPI: `${process.env.BASE_URL}api${
		window.__env.ConfigApplication.groupApplication == 'trial'
			? ''
			: `/${window.__env.ConfigApplication.groupApplication}`
	}`,
	SignalR: window.__env.pushConfig.push_url,
	InvoiceBotTrialsAPI: `${process.env.BASE_URL}trial-api`,
	InternalAPI: `${process.env.BASE_URL}internalapi`
};

// Cấu hình api
const api = {
	production: apiConfigProduction,
	devtest: apiConfigProduction,
	development: apiConfigDevLocal
};

export default api[process.env.NODE_ENV];
